/**
 * Generates the marketplace conversation URL for a given conversation ID
 * @param conversationId - The ID of the conversation
 * @returns The full URL to the conversation in the marketplace frontend
 */
export function marketplaceConversationUrl(conversationId: string): string {
  const baseUrl = import.meta.env.VITE_MARKETPLACE_FRONTEND_URL
    ? import.meta.env.VITE_MARKETPLACE_FRONTEND_URL
    : ''

  return `${baseUrl}/conversations/${conversationId}`
}
